import { request } from "@/utilities/libs/request.ts";
import {
  IRequestArgs,
  IResponseData,
  ListResponseData,
} from "@/utilities/types/requests.ts";
import { ERequestMethods } from "@/utilities/enums/RequestMethod.ts";
import {
  ICheckCNames,
  ILandingPage,
  ILandingPageDataForm,
} from "../types/LandingPage";
import { LANDINGPAGES } from "../enums/LandingPages";

function getLandingPages({ queryParams }: IRequestArgs) {
  const query = {
    filter: queryParams?.query?.filter,
    ...queryParams?.pagination,
    ...queryParams?.query?.search,
  };

  return request<ListResponseData<ILandingPage>>({
    method: ERequestMethods.GET,
    url: LANDINGPAGES.GET,
    params: query,
  });
}

function getLandingPagesByProject({ queryParams }: IRequestArgs) {
  const query = {
    ...queryParams?.pagination,
  };
  return request<ListResponseData<ILandingPage>>({
    method: ERequestMethods.GET,
    url:
      LANDINGPAGES.GET_BY_PROJECT +
      `/${queryParams?.query?.filter[0].projectId}`,
    params: query,
  });
}

function createLandingPage(data: ILandingPageDataForm) {
  return request<IResponseData<ILandingPage>>({
    method: ERequestMethods.POST,
    url: LANDINGPAGES.CREATE,
    data,
  });
}

function updateLandingPage(id: string, data: Partial<ILandingPageDataForm>) {
  return request<IResponseData<ILandingPage>>({
    method: ERequestMethods.PATCH,
    url: LANDINGPAGES.UPDATE(id),
    data,
  });
}

function removeLandingPage(id: string) {
  return request<IResponseData<ILandingPage>>({
    method: ERequestMethods.DELETE,
    url: LANDINGPAGES.REMOVE(id),
  });
}

function checkProjectExists(params: { userId: string; projectId: string }) {
  return request<IResponseData<boolean>>({
    method: ERequestMethods.GET,
    url: LANDINGPAGES.CHECK_PROJECT_EXISTS,
    params,
  });
}

function checkCnameConnection(body: { domain: string }) {
  return request<IResponseData<boolean>>({
    method: ERequestMethods.POST,
    url: LANDINGPAGES.CHECK_CNAME_CONNECTION,
    data: body,
  });
}

function checkCnamesConnection(body: { domain: string }) {
  return request<IResponseData<ICheckCNames>>({
    method: ERequestMethods.POST,
    url: LANDINGPAGES.CHECK_CNAMES_CONNECTION,
    data: body,
  });
}

const LandingPagesRepository = Object.freeze({
  getLandingPages,
  getLandingPagesByProject,
  createLandingPage,
  updateLandingPage,
  removeLandingPage,
  checkProjectExists,
  checkCnameConnection,
  checkCnamesConnection,
});

export default LandingPagesRepository;
